export default {"src":"/_next/static/media/eligibility.43cca8c2.svg","height":184,"width":227};